import { useState } from "react";
import { useBranchData } from "./useBranchData";
import { useUpdateVisibility } from "./useUpdateVisibility";
import { useBranchUpdate } from "./useBranchUpdate";

export const useEditBranch = (
  id: string,
  formData: any,
  updateFormData: (data: Partial<any>) => void,
  doberror: boolean,
  error: string,
  closeEdit: () => void,
  fetchBranches: () => void
) => {
  /** Load original data into form */
  const branchData = useBranchData(id, updateFormData); // ✅ FIXED

  /** Update button visibility */
  const visible = useUpdateVisibility(formData, branchData, error, doberror);

  /** Date dirty flag */
  const [dateDirty, setDateDirty] = useState(false);

  /** PATCH update */
  const { loading, updateBranch } = useBranchUpdate(
    id,
    formData,
    branchData,
    closeEdit,
    fetchBranches,
    dateDirty
  );

  return {
    loading,
    visible,
    updateBranch,
    setDateDirty,
  };
};
